import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updatePurchaseCheck } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunPurchaseCheckUpdate',
  components: {},
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      title: '',
      formData: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.formData = _this2.initData();
              _this.title = _this.$route.params.meta.title;
              _this.formData = Object.assign(_this.formData, _this.$route.params.row);
              _this.formData.dailyDate = _this.formData.dailyDate + '';
              _this.formData.stationName = _this.$options.filters.getSellerName(_this.formData.stationId);

              _this.onChangeStation();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    initData: function initData() {
      return {
        stationId: '',
        stationName: '',
        dailyDate: '',
        oilCode: '',
        totalGiveInTon: '',
        totalGiveInLiters: ''
      };
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onClear: function onClear() {
      this.formData.oilCode = '';
      this.formData.totalGiveInTon = '';
      this.formData.totalGiveInLiters = '';
    },
    onSave: function onSave() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.formData.stationId) {
                  _context3.next = 3;
                  break;
                }

                _this3.$message({
                  type: 'warning',
                  message: '油站不能为空！'
                });

                return _context3.abrupt("return");

              case 3:
                if (_this3.formData.dailyDate) {
                  _context3.next = 6;
                  break;
                }

                _this3.$message({
                  type: 'warning',
                  message: '日期不能为空！'
                });

                return _context3.abrupt("return");

              case 6:
                if (_this3.formData.totalGiveInTon) {
                  _context3.next = 9;
                  break;
                }

                _this3.$message({
                  type: 'warning',
                  message: '进油吨数不能为空！'
                });

                return _context3.abrupt("return");

              case 9:
                if (_this3.formData.totalGiveInLiters) {
                  _context3.next = 12;
                  break;
                }

                _this3.$message({
                  type: 'warning',
                  message: '进油升数不能为空！'
                });

                return _context3.abrupt("return");

              case 12:
                _context3.next = 14;
                return updatePurchaseCheck({
                  'ID': _this3.formData.ID,
                  'stationId': _this3.formData.stationId,
                  'dailyDate': Number(_this3.formData.dailyDate),
                  'oilCode': _this3.formData.oilCode,
                  'totalGiveInTon': _this3.formData.totalGiveInTon,
                  'totalGiveInLiters': _this3.formData.totalGiveInLiters
                });

              case 14:
                res = _context3.sent;

                if (res.code == 0) {
                  _this3.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  setTimeout(function () {
                    _this3.goBack();
                  }, 300);
                }

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};